module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>Settings</span>\n</h2>\n"